import { BaseDto } from './base.dto';

export class RecipeBookDto extends BaseDto {
  name: string;
}
